export default __webpack_public_path__ + "sounds/keypress-delete.wav";